<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>

      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='8' :sm='10'>
            <a-form-item :label="'下单日期'">
              <a-range-picker
                v-model='queryParam.submitDate'
                format='YYYY-MM-DD'
                style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'ProductType')">
              <a-select
                        v-model='queryParam.appSsid'
              >
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>

            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'费率'">
              <a-select default-value='' style='width: 120px' v-model='queryParam.type'>
                <a-select-option value=''>
                  全部
                </a-select-option>
                <a-select-option value='1'>
                  product_740
                </a-select-option>
                <a-select-option value='2'>
                  product_745
                </a-select-option>
                <a-select-option value='3'>
                  其他
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>


      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered>
      </a-table>

    </div>

  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getApplist} from '@/webpublicapi/order'
import moment from 'moment'
import { loanCountStatics } from '@/webpublicapi/statistics'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.'
}

export default {
  name: 'loanCountStatic',
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      deadlineConfigList: [],
      appList: [],
      // 查询条件
      queryParam: {
        submitDate:[moment().add('days', -14), moment().add('days', -7)],
        appSsid: '',
        type: '',
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '贷款次数',
          align: 'left',
          dataIndex: 'loanCount'
        },
        {
          title: '订单数',
          align: 'left',
          dataIndex: 'totalCount'
        },
        {
          title: '放款数',
          align: 'left',
          dataIndex: 'payoutCount'
        },
        {
          title: '放款率',
          align: 'left',
          dataIndex: 'payoutAvg',
          customRender:(text)=>{
            return text + '%';
          }
        },
        {
          title: '复贷数',
          align: 'left',
          dataIndex: 'reloanCount'
        },
        {
          title: '复贷率（还款）',
          align: 'left',
          dataIndex: 'reloanAvg',
          customRender:(text)=>{
            if(text === -1)
              return '-'
            return text + '%';
          }
        },
        {
          title: '复贷率（总数）',
          align: 'left',
          dataIndex: 'reloanTotalAvg',
          customRender:(text)=>{
            return text + '%';
          }
        },
        {
          title: '还款数',
          align: 'left',
          dataIndex: 'settelDiferCount'
        },
        {
          title: '还款数(非展期)',
          align: 'left',
          dataIndex: 'settelCount'
        },
        {
          title: '坏账率',
          align: 'left',
          dataIndex: 'unsettelAvg',
          customRender:(text)=>{
            if(text === -1)
              return '-'
            return text + '%';
          }
        },
        {
          title: '件均',
          align: 'left',
          dataIndex: 'applyAvg',
          customRender:(text)=>{
            return this.formatMoney(text);
          }
        },
        {
          title: '合同额',
          align: 'left',
          dataIndex: 'applySum',
          customRender:(text)=>{
            return this.formatMoney(text);
          }
        },
        {
          title: '放款额',
          align: 'left',
          dataIndex: 'payoutSum',
          customRender:(text)=>{
            return this.formatMoney(text);
          }
        },
        {
          title: '还款额',
          align: 'left',
          dataIndex: 'repaySum',
          customRender:(text)=>{
            return this.formatMoney(text);
          }
        },
        {
          title: '利润',
          align: 'left',
          dataIndex: 'profitSum',
          customRender:(text)=>{
            return this.formatMoney(text);
          }
        },
        {
          title: '在贷数',
          align: 'left',
          dataIndex: 'loaningCount'
        },
        {
          title: '在贷额(合同)',
          align: 'left',
          dataIndex: 'loaningApplySum',
          customRender:(text)=>{
            return this.formatMoney(text);
          }
        },
        {
          title: '在贷额(放款)',
          align: 'left',
          dataIndex: 'loaningPaySum',
          customRender:(text)=>{
            return this.formatMoney(text);
          }
        },
      ]
    }
  },
  created() {

    getApplist().then(res => {
      // this.appList = res.data || []

      let filteredData = res.data || []
      filteredData = filteredData.filter((item, index) =>
        item && item.appssid && item.appssid.length === 3
      )

      this.appList = filteredData
      this.queryParam.appSsid = this.appList[0].appssid
    })



  },
  methods: {
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData()
    },
    loadData(arg) {

      this.loading = true
      var params = this.getQueryParams()// 查询条件
      loanCountStatics(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          // this.total = res.data.total
          if(res.data && res.data.length > 0)
              res.data[0].loanCount = 'total'
          this.dataSource = res.data || []

        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },

    getQueryParams() {
      const { submitDate } = this.queryParam
      const data = {
        ...this.queryParam,
        beginDate: (submitDate && submitDate.length) ? this.transformTime(submitDate[0]) : undefined,
        endDate: (submitDate && submitDate.length) ? this.transformTime(submitDate[1]) : undefined
      }
      delete data.submitDate
      let param = Object.assign({}, data)

      return filterObj(param)
    },

    // 重置字典类型搜索框的内容
    searchReset() {
      let that = this
      that.queryParam.submitDate = [moment().add('days', -14), moment().add('days', -7)],
      that.queryParam.appSsid = this.appList[0].appssid
      that.queryParam.type = ''
    },
    changeModal(visible) {
      this.visible = visible
    },

    formatMoney(num, decimals=2) {
       num = parseFloat((num + "").replace(/[^\d.-]/g, ""));
      return num.toFixed(decimals).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
